import { Routes, Route } from "react-router-dom";
import Home from "@/features/home/Home";
import Login from "@/features/login/Login";
import SocialContact from "@/features/home/SocialContact";
import AccessDenied from "@/features/access/AccessDenied";
import ProtectedRoute from "./ProtectedRoute";
import StudentDashboard from "@/features/studentDashboard/StudentDashboard";
import CoordinatorDashboard from "@/features/coordinatorDashboard/CoordinatorDashboard";
import UserManagement from "@/features/userManagement/UserManagement";
import FacilitatorPanel from "@/features/facilitatorPanel/FacilitatorPanel";
import SimulationManagement from "@/features/simulationManagement/SimulationManagement";
import SimulationConfiguration from "@/features/simulationConfiguration/SimulationConfiguration";
import StudentAssignments from "@/features/studentAssignment/StudentAssignment";
import StudentSimulationManagement from "@/features/studentSimulationManagement/StudentSimulationManagement";
import StudentHome from "@/features/studentHome/StudentHome";
import StudentSimulations from "@/features/studentVirtualSimulations/StudentSimulations";
import VirtualSimulationPresenter from "@/features/studentVirtualSimulations/VirtualSimulationPresenter";
import LegalDocumentPage from "@/features/compliance/LegalDocumentPage";
import MyData from "@/features/compliance/MyData";


const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/login" element={<Login />} />

            <Route path="/access-denied" element={<AccessDenied />} />
            <Route path="/social-contact" element={<SocialContact />} />

            {/* Páginas públicas de protección de datos (Ley 1581) */}
            <Route
                path="/politica-de-tratamiento"
                element={<LegalDocumentPage docType="policy" />}
            />
            <Route
                path="/aviso-de-privacidad"
                element={<LegalDocumentPage docType="privacy_notice" />}
            />

            {/* Mis datos: derechos del titular (cualquier usuario autenticado) */}
            <Route
                path="/mis-datos"
                element={
                    <ProtectedRoute allowedRoles={['Estudiante', 'Facilitador', 'Coordinador de curso']}>
                        <MyData />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/student-dashboard"
                element={
                    <ProtectedRoute allowedRoles={['Estudiante', 'Facilitador', 'Coordinador de curso']}>
                        <StudentDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/student-home"
                element={
                    <ProtectedRoute allowedRoles={['Estudiante', 'Facilitador', 'Coordinador de curso']}>
                        <StudentHome />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/student/virtual-simulations"
                element={
                    <ProtectedRoute allowedRoles={['Estudiante']}>
                        <StudentSimulations />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/student/virtual-simulations/:simulationId"
                element={
                    <ProtectedRoute allowedRoles={['Estudiante']}>
                        <VirtualSimulationPresenter />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/coordinator-dashboard"
                element={
                    <ProtectedRoute allowedRoles={['Coordinador de curso', 'Facilitador']}>
                        <CoordinatorDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/facilitator-panel"
                element={
                    <ProtectedRoute allowedRoles={['Facilitador']}>
                        <FacilitatorPanel />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/facilitator-panel/user-management"
                element={
                    <ProtectedRoute allowedRoles={['Facilitador']}>
                        <UserManagement />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/facilitator-panel/user-management/:userId/assignments"
                element={
                    <ProtectedRoute allowedRoles={['Facilitador']}>
                        <StudentAssignments />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/facilitator-panel/user-management/:userId/assignments/:simulationId/answers"
                element={
                    <ProtectedRoute allowedRoles={['Facilitador']}>
                        <StudentSimulationManagement />
                    </ProtectedRoute>
                }
            />


            <Route
                path="/facilitator-panel/simulations"
                element={
                    <ProtectedRoute allowedRoles={['Facilitador']}>
                        <SimulationManagement />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/facilitator-panel/simulations/:simulationId/configure"
                element={
                    <ProtectedRoute allowedRoles={['Facilitador']}>
                        <SimulationConfiguration />
                    </ProtectedRoute>
                }
            />


            {/*

            */}
        </Routes>
    );
};

export default AppRoutes;
